export const VERSION_NUMBER = '1.007';
export const BUILD_TIME = '2026-03-12T01:20:26.328Z';
export const BUILD_NOTES =
    '<ul><li>Fixed issue with closing auction via Close Auction button.</li><li>Added PDF button to download winners list after auction is closed out.</li></ul>';
